import React from 'react';
import { Home, MonitorPlay, Mic2, Camera, Settings } from 'lucide-react';
interface NavigationBarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}
export function NavigationBar({
  activeTab,
  onTabChange
}: NavigationBarProps) {
  const tabs = [{
    id: 'home',
    label: 'Home',
    icon: Home
  }, {
    id: 'video',
    label: 'Video',
    icon: MonitorPlay
  }, {
    id: 'audio',
    label: 'Audio',
    icon: Mic2
  }, {
    id: 'cameras',
    label: 'Cameras',
    icon: Camera
  }, {
    id: 'advanced',
    label: 'Advanced',
    icon: Settings,
    separate: true
  }];
  return <div className="h-[64px] bg-neutral-900 border-t border-neutral-700 flex items-stretch px-2 pb-1.5 pt-1 gap-2" data-id="element-250">
      {tabs.map(tab => {
      const isActive = activeTab === tab.id;
      const Icon = tab.icon;
      return <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`
              flex-1 flex flex-col items-center justify-center rounded-lg transition-all duration-200
              ${tab.separate ? 'ml-auto max-w-[120px] border-l border-neutral-800' : ''}
              ${isActive ? 'bg-blue-600 text-white shadow-[0_0_15px_rgba(37,99,235,0.3)] translate-y-[-2px]' : 'bg-neutral-800 text-gray-400 hover:bg-neutral-700 hover:text-gray-200'}
            `} data-id="element-251">
            <Icon size={22} className={`mb-0.5 ${isActive ? 'stroke-[2.5px]' : 'stroke-[1.5px]'}`} data-id="element-252" />
            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-253">
              {tab.label}
            </span>
          </button>;
    })}
    </div>;
}